import React from 'react';
import { FooterWrapper } from './footer.styled';
import Container from '../container/container.component';

import TwitterIcon from '&assets/images/twitter.svg';
import FacebookIcon from '&assets/images/facebook.svg';
import YoutubeIcon from '&assets/images/youtube.svg';
import SnapchatIcon from '&assets/images/snapchat.svg';
import InstagramIcon from '&assets/images/instagram.svg';
import LogoImg from '&assets/images/logo-secondary.png';

interface Props {
	className?: string;
}

const socials = {
	facebook: 'https://www.facebook.com/gustkwt/',
	twitter: 'https://twitter.com/gust_official',
	instagram: 'https://www.instagram.com/gust_official',
	youtube: 'https://www.youtube.com/channel/UCRRJ6gc7Mf1dIhKg-CrO5tQ',
	snapchat: 'https://www.snapchat.com/add/gust_official',
};

const Footer = (props: Props) => {
	const { className } = props;
	return (
		<FooterWrapper className={className ? className : ''}>
			<Container>
				<div className="footer-content">
					<img src={LogoImg} alt="" className="footer-logo" />
					<p className="footer-middleText">
						Copyright © 2023 GUST. All Rights Reserved
					</p>
					<div className="socials">
						<a
							className="box facebook"
							target="_blank"
							href={socials.facebook}
							rel="noreferrer"
						>
							<img src={FacebookIcon} alt="facebook" />
						</a>
						<a
							className="box twitter"
							target="_blank"
							href={socials.twitter}
							rel="noreferrer"
						>
							<img src={TwitterIcon} alt="twitter" />
						</a>
						<a
							className="box instagram"
							target="_blank"
							href={socials.instagram}
							rel="noreferrer"
						>
							<img src={InstagramIcon} alt="instagram" />
						</a>
						<a
							className="box youtube"
							target="_blank"
							href={socials.youtube}
							rel="noreferrer"
						>
							<img src={YoutubeIcon} alt="youtube" />
						</a>
						<a
							className="box snapchat"
							target="_blank"
							href={socials.snapchat}
							rel="noreferrer"
						>
							<img src={SnapchatIcon} alt="snapchat" />
						</a>
					</div>
				</div>
			</Container>
		</FooterWrapper>
	);
};

export default Footer;
